<div fxLayout="row" fxLayoutAlign="space-between start">
<div fxLayout="column" fxLayoutAlign="center center" fxFlex="40" style="background:#e40601">
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  <div class="" fxLayout="row">
    <span class="material-symbols-outlined">
      <mat-icon>support_agent</mat-icon>
    </span>
    <h1 style="color:white">{{'REQUERIMIENTOSV3.CONTAC' | translate}}</h1>
  </div>
    <span style="color:white">{{'REQUERIMIENTOSV3.CONTAC_DES' | translate}}</span>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>

  </div>
  <div class="" fxFlex="60" fxLayout="column" >
    <div class="" fxLayout="row" fxLayoutAlign="center center">
      <h1>{{'REQUERIMIENTOSV3.SEND_EMA' | translate}}</h1>
    </div>

    <div class="" fxLayout="row">
      <mat-form-field class="p-5 ml-10" appearance="outline" fxFlex="100" >
        <mat-label>{{'REQUERIMIENTOSV3.LABEL' | translate}}</mat-label>
        <textarea matInput [(ngModel)]="description"></textarea>
        <mat-error>Campo requerido</mat-error>
        <!-- <input type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [(ngModel)]="correosPilotos[i].email" (blur)="validarDato($event,i)"> -->
      </mat-form-field>
    </div>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <div class="" fxLayout="row" fxFlex="40" fxLayoutAlign="end end">
      <button mat-raised-button color="primary"  [disabled]="description==''" (click)="envioCorreoAyudaRT()">
        {{'REQUERIMIENTOSV3.TEX_BTN_SEND' | translate}} <mat-icon >send</mat-icon>
      </button>
    </div>
  </div>
</div>
